import React from 'react';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { motion } from 'framer-motion';
export function ProductDetails() {
  const tomo1Features = ['La Emulsión BEH (Base de Humectación Secreta)', '20+ variedades Gourmet (mucho más que jamón y queso)', 'Técnica de corte en bloque — Cero desperdicio', 'Rellenos Ultra-Cremosos que no se caen', 'Conservación profesional hasta 48 horas sin heladera industrial', 'El Prensado de Fusión (el secreto que nadie cuenta)', 'Plan de acción para tus primeros 100 sándwiches'];
  const tomo2Features = ['La Regla del 30/30/40 (la estructura financiera del éxito)', 'Sistema de Línea de Ensamblaje para eventos grandes', 'Cómo vender a empresas y organizadores de eventos', 'El Método B2B — Empresas que compran todas las semanas', 'Alianzas con Wedding Planners y organizadores de fiestas', 'Protocolo de Entrega "Guante Blanco"', 'Cómo cobrar el servicio de entrega y montaje de bandejas'];
  const sharedFeatures = ['Técnica paso a paso con descripciones detalladas', 'Recetas con gramajes exactos', 'Estrategias de precio y margen', 'Errores críticos a evitar', 'Plan de producción para distintas cantidades', '100% orientado al mercado argentino'];
  return <section className="py-14 bg-brand-dark text-white" data-id="element-298">
      <div className="max-w-6xl mx-auto px-4 md:px-8" data-id="element-299">
        <div className="text-center mb-10" data-id="element-300">
          <div className="inline-block bg-brand-gold text-white font-bold px-4 py-1 rounded-full text-sm mb-4 tracking-wider" data-id="element-301">
            🏆 MIGA MASTER PRO™
          </div>
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-3" data-id="element-302">
            2 Tomos + 3 Bonos — El sistema completo
          </h2>
          <p className="text-xl md:text-2xl text-brand-gold font-medium" data-id="element-303">
            120+ páginas — Todo resuelto.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-10" data-id="element-304">
          {/* Tomo I */}
          <motion.div className="bg-white text-brand-dark rounded-3xl p-6 md:p-8 shadow-xl" initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-305">
            <div className="text-brand-gold font-bold text-lg mb-1" data-id="element-306">
              📘 TOMO I
            </div>
            <h3 className="text-2xl md:text-3xl font-serif font-bold mb-3" data-id="element-307">
              La Biblia de la Miga Perfecta
            </h3>
            <h4 className="text-lg font-semibold text-brand-gray mb-4" data-id="element-308">
              Técnica Gourmet de las Grandes Confiterías
            </h4>
            <p className="text-brand-gray mb-5" data-id="element-309">
              El secreto de la humectación de 48 horas, el corte perfecto sin
              desperdicio y las combinaciones que tus clientes no pueden dejar
              de comer.
            </p>
            <ul className="space-y-3" data-id="element-310">
              {tomo1Features.map((feature, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-311">
                  <CheckCircleIcon className="text-brand-green flex-shrink-0 mt-0.5" data-id="element-312" />
                  <span className="font-medium" data-id="element-313">{feature}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* Tomo II */}
          <motion.div className="bg-white text-brand-dark rounded-3xl p-6 md:p-8 shadow-xl" initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} data-id="element-314">
            <div className="text-brand-gold font-bold text-lg mb-1" data-id="element-315">
              📗 TOMO II
            </div>
            <h3 className="text-2xl md:text-3xl font-serif font-bold mb-3" data-id="element-316">
              De la Cocina al Imperio del Catering
            </h3>
            <h4 className="text-lg font-semibold text-brand-gray mb-4" data-id="element-317">
              El Negocio, los Números y el Escalado
            </h4>
            <p className="text-brand-gray mb-5" data-id="element-318">
              Cómo pasar de hacer 12 sándwiches para la familia a producir 500
              para eventos y ganar un 60% de margen real.
            </p>
            <ul className="space-y-3" data-id="element-319">
              {tomo2Features.map((feature, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-320">
                  <CheckCircleIcon className="text-brand-green flex-shrink-0 mt-0.5" data-id="element-321" />
                  <span className="font-medium" data-id="element-322">{feature}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>

        {/* Shared Features */}
        <div className="bg-brand-gray bg-opacity-20 rounded-3xl p-6 md:p-8 border border-gray-700 max-w-4xl mx-auto" data-id="element-323">
          <h3 className="text-2xl font-serif font-bold text-center mb-5 text-brand-gold" data-id="element-324">
            Cada tomo incluye:
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-325">
            {sharedFeatures.map((feature, idx) => <div key={idx} className="flex items-start gap-3" data-id="element-326">
                <CheckCircleIcon className="text-brand-gold flex-shrink-0 mt-0.5" data-id="element-327" />
                <span className="text-lg" data-id="element-328">{feature}</span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}